import script from "./SnoozeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SnoozeModal.vue?vue&type=script&setup=true&lang=js"

import "./SnoozeModal.vue?vue&type=style&index=0&id=178a7010&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178a7010"]])

export default __exports__